// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GL3g","toggle":"styles_toggle__3q0jP","preview":"styles_preview__m1skE"};